import dateTimeHelper from '../Helpers/datetimeHelper';

export default class FinalizeTpClientInvoiceItem {
  constructor() {
    this.TpClientInvoiceId = 0;
    this.OfficeId = 0;
    this.FulfillmentDate = new Date(dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(new Date(), 1)));
    this.Comment = '';
  }
}
